import * as Yup from 'yup';
import Translator from '../../core/i18n';
import { Common } from '../../core/common';
import { IValidation } from '../../models/components/validation-props';
import { DateCriteria } from '../../models/enums/dateCriteria';
import { Log } from 'ng2-logger';
import Moment from 'moment';
import { IExamQuestionWeights } from '../action/exam';
import { IExamSessionList } from '../action/examSession';

const _logger = Log.create('main-validaitons');
const T = Translator.create();
const _common = new Common();

//#region "Regular Expression for date inputs"
const RegExpDate = /^[0-9]{2}.[0-9]{2}.[0-9]{4}$/;
const RegExpTime = /^$|^(([01][0-9])|(2[0-3])):[0-5][0-9]$/;
const RegExpDateRange = /^[0-9]{2}.[0-9]{2}.[0-9]{4}[" "][-][" "][0-9]{2}.[0-9]{2}.[0-9]{4}$/;
const RegExpHtmlTags = /(<([^>]+)>)/gi;
const RegExpBase64 = /<img([^>]+)src="(data:image\/[^;]+;base64[^"]+)"/i;
//#endregion

// Default accesible values - filled if exists
let dateCriteria: any = null;
let dateRange: any = null;
let termWeekIds: any = null;
let customProperty5Date: any = null;
let customProperty5Time: any = null;
let examSessionBeginDate: any = null;
let examSessionBeginDateTime: any = null;
let examSessionEndDate: any = null;
let examSessionEndDateTime: any = null;
let examShowAnswerSpecifiedDate: any = null;
let examShowAnswerSpecifiedDateTime: any = null;
let customProperty4: any = null;
let examQuestionCount: any = null;
let examQuestionWeightingType: any = null;
let taskDeadlineDate: any = null;
let taskDeadlineTime: any = null;
let props: IValidation = {};
let startTimeHour: any = null;
let examEntryDateType: any = null;

export class DefaultValidation {
    constructor(_props?: IValidation) {
        props = _props ? _props : {};
    }

    // dateCriteria - dateRange - termWeekIds heryerde erişilebilir olmasi icin bu fonksiyonu cagir
    SetDefaultValues() {
        return Yup.bool().test({
            name: 'defaultValuesFormik',
            // tslint:disable-next-line
            test: function (value: any) {
                dateCriteria = this.parent.dateCriteria;
                dateRange = this.parent.dateRange;
                termWeekIds = this.parent.termWeekIds;
                customProperty5Date = this.parent.customProperty5Date;
                customProperty5Time = this.parent.customProperty5Time;
                examSessionBeginDate = this.parent.examSessionBeginDate;
                examSessionBeginDateTime = this.parent.examSessionBeginDateTime;
                examSessionEndDate = this.parent.examSessionEndDate;
                examSessionEndDateTime = this.parent.examSessionEndDateTime;
                examShowAnswerSpecifiedDate = this.parent.examShowAnswerSpecifiedDate;
                examShowAnswerSpecifiedDateTime = this.parent.examShowAnswerSpecifiedDateTime;
                customProperty4 = this.parent.customProperty4;
                examQuestionCount = this.parent.examQuestionCount;
                examQuestionWeightingType = this.parent.examQuestionWeightingType;
                taskDeadlineDate = this.parent.taskDeadline;
                taskDeadlineTime = this.parent.taskDeadlinetime;
                startTimeHour = this.parent.startTimeHour;
                examEntryDateType = this.parent.examEntryDateType;
                return true;
            }
        });
    }

    //#region "Getter input validation functions"
    GetName() {
        return Yup.string()
            .trim()
            .min(1, T.t('r_one_character_required_validation'))
            .max(255, T.t('r_must_be_less_characters_validation'))
            .required(T.t('r_name_required_validation'));
    }

    GetUrl() {
        return Yup.string()
            .trim()
            .min(1, T.t('r_one_character_required_validation'))
            .required(T.t('r_url_required_validation'));
    }

    GetDescription() {
        return Yup.string()
            .trim()
            .min(1, T.t('r_one_character_required_validation'))
            .max(255, T.t('r_must_be_less_characters_validation'))
            .required(T.t('r_description_required_validation'));
    }

    GetTaskDeadLine() {
        return Yup.string()
            .min(1, T.t('r_one_character_required_validation'))
            .matches(RegExpDate, T.t('r_date_format_incorrect_validation'))
            .required(T.t('r_date_required_validation'))
            .test(
                'taskDeadline',
                T.t('r_enter_start_and_end_date_validation', {
                    0: _common.dateConvertToString(props.startDate, props.dateFormat),
                    1: _common.dateConvertToString(props.endDate, props.dateFormat)
                }),
                // tslint:disable-next-line
                function (dateValue: any) {
                    if (props.startDate && props.endDate && dateValue) {
                        return _common.isDateRangeValid(props.startDate, props.endDate, dateValue, 1, props.dateFormat);
                    }
                    return true;
                }
            )
            .test({
                name: 'taskDeadline',
                // tslint:disable-next-line
                test: function (dateValue: any) {
                    if (dateValue) {
                        let isValid: boolean | null = true;
                        let errorMessage = '';
                        if (dateCriteria === DateCriteria.week) {
                            // taskDeadline daki tarih seçilen haftalar arasindaki tarihte mi? validasyon fonksiyonu
                            isValid = _common.isTaskDeadLineDateInWeeks(props.termWeeks, termWeekIds, dateValue, props.dateFormat);
                            errorMessage = T.t('r_taskDeadline_not_in_selected_week_dates');
                        } else if (dateCriteria === DateCriteria.timeInterval && dateRange) {
                            // taskDeadline secili zaman aralığında mı? validasyon
                            isValid = _common.isDateRangeValid(dateValue, dateValue, dateRange, 3, props.dateFormat);
                            errorMessage = T.t('r_taskDeadline_not_in_selected_date_range');
                        }
                        return isValid
                            ? true
                            : this.createError({
                                message: errorMessage,
                                path: 'taskDeadline'
                            });
                    }
                    return true;
                }
            })
            .test({
                name: 'taskDeadline',
                // tslint:disable-next-line
                test: function (dateValue: any) {
                    if (dateValue) {
                        let isValid: boolean | null = true;
                        let errorMessage = '';
                        const selectedDateFormat = props.dateFormat ? props.dateFormat : window.appSettings.DefaultDateFormat;
                        if (customProperty5Date && customProperty5Time) {
                            const assignmentBeginDate = Moment(
                                customProperty5Date + ' ' + customProperty5Time,
                                selectedDateFormat + ' HH:mm'
                            );
                            const taskDeadline = Moment(taskDeadlineDate + ' ' + taskDeadlineTime, selectedDateFormat + ' HH:mm');
                            if (assignmentBeginDate < taskDeadline) {
                                isValid = true;
                            } else {
                                isValid = false;
                                errorMessage = T.t('r_taskDeadline_not_be_past_begin_date');
                            }
                        }
                        return isValid
                            ? true
                            : this.createError({
                                message: errorMessage,
                                path: 'taskDeadline'
                            });
                    }
                    return true;
                }
            });
    }

    GetTaskDeadLineTime() {
        return Yup.string()
            .min(1, T.t('r_one_character_required_validation'))
            .matches(RegExpTime, T.t('r_incorrect_input_format_validation'))
            .required(T.t('r_time_input_required_validation'));
    }
    GetCustomProperty5Date() {
        return Yup.string()
            .min(1, T.t('r_one_character_required_validation'))
            .matches(RegExpDate, T.t('r_date_format_incorrect_validation'))
            .required(T.t('r_date_required_validation'))
            .test(
                'customProperty5Date',
                T.t('r_enter_start_and_end_date_validation', {
                    0: _common.dateConvertToString(props.startDate, props.dateFormat),
                    1: _common.dateConvertToString(props.endDate, props.dateFormat)
                }),
                // tslint:disable-next-line
                function (dateValue: any) {
                    if (props.startDate && props.endDate && dateValue) {
                        return _common.isDateRangeValid(props.startDate, props.endDate, dateValue, 1, props.dateFormat);
                    }
                    return true;
                }
            )
            .test({
                name: 'customProperty5Date',
                // tslint:disable-next-line
                test: function (dateValue: any) {
                    if (dateValue) {
                        let isValid: boolean | null = true;
                        let errorMessage = '';
                        if (dateCriteria === DateCriteria.week) {
                            // taskDeadline daki tarih seçilen haftalar arasindaki tarihte mi? validasyon fonksiyonu
                            isValid = _common.isTaskDeadLineDateInWeeks(props.termWeeks, termWeekIds, dateValue, props.dateFormat);
                            errorMessage = T.t('r_taskDeadline_not_in_selected_week_dates');
                        } else if (dateCriteria === DateCriteria.timeInterval && dateRange) {
                            // taskDeadline secili zaman aralığında mı? validasyon
                            isValid = _common.isDateRangeValid(dateValue, dateValue, dateRange, 3, props.dateFormat);
                            errorMessage = T.t('r_taskDeadline_not_in_selected_date_range');
                        }
                        return isValid
                            ? true
                            : this.createError({
                                message: errorMessage,
                                path: 'customProperty5Date'
                            });
                    }
                    return true;
                }
            });
    }

    GetCustomProperty5Time() {
        return Yup.string()
            .min(1, T.t('r_one_character_required_validation'))
            .matches(RegExpTime, T.t('r_incorrect_input_format_validation'))
            .required(T.t('r_time_input_required_validation'));
    }

    GetDateRange() {
        return Yup.string().when('dateCriteria', {
            is: val => val === 1,
            then: Yup.string()
                .required(T.t('r_video_warning_fieldrequired'))
                .matches(RegExpDateRange, T.t('r_date_format_incorrect_validation'))
                .test(
                    'dateRange',
                    T.t('r_enter_start_and_end_date_validation', {
                        0: _common.dateConvertToString(props.startDate, props.dateFormat),
                        1: _common.dateConvertToString(props.endDate, props.dateFormat)
                    }),
                    // tslint:disable-next-line
                    function (dateValue: any) {
                        if (props.startDate && props.endDate && dateValue) {
                            return _common.isDateRangeValid(props.startDate, props.endDate, dateValue, 2, props.dateFormat);
                        }
                        return true;
                    }
                )
        });
    }

    GetActivityBeginDate() {
        return Yup.string().when('dateCriteria', {
            is: val => val === 1,
            then: Yup.string()
                .required(T.t('r_date_required_validation'))
                .matches(RegExpDate, T.t('r_date_format_incorrect_validation'))
                .test(
                    'activityBeginDate',
                    T.t('r_enter_start_and_end_date_validation', {
                        0: _common.dateConvertToString(props.startDate, props.dateFormat),
                        1: _common.dateConvertToString(props.endDate, props.dateFormat)
                    }),
                    // tslint:disable-next-line
                    function (dateValue: any) {

                        if (props.startDate && props.endDate && dateValue) {
                            return _common.isDateRangeValid(props.startDate, props.endDate, dateValue, 2, props.dateFormat);
                        }
                        return true;
                    }
                )
        });
    }

    GetActivityBeginTime() {
        return Yup.string().when('dateCriteria', {
            is: val => val === 1,
            then: Yup.string()
                .min(1, T.t('r_one_character_required_validation'))
                .matches(RegExpTime, T.t('r_incorrect_input_format_validation'))
                .required(T.t('r_time_input_required_validation'))
        });
    }

    GetActivityEndDate() {
        return Yup.string().when('dateCriteria', {
            is: val => val === 1,
            then: Yup.string()
                .required(T.t('r_date_required_validation'))
                .matches(RegExpDate, T.t('r_date_format_incorrect_validation'))
                .test(
                    'activityEndDate',
                    T.t('r_enter_start_and_end_date_validation', {
                        0: _common.dateConvertToString(props.startDate, props.dateFormat),
                        1: _common.dateConvertToString(props.endDate, props.dateFormat)
                    }),
                    // tslint:disable-next-line
                    function (dateValue: any) {
                        let isValid: boolean | null = true;
                        let errorMessage = '';
                        let partsBeginDate = (this.parent.activityBeginDate + '.' + this.parent.activityBeginTime).split(".");
                        let beginDate = new Date(partsBeginDate[2] + '/' + partsBeginDate[1] + '/' + partsBeginDate[0] + ' ' + partsBeginDate[3]);

                        let partsEndDate = (this.parent.activityEndDate + '.' + this.parent.activityEndTime).split(".");
                        let endDate = new Date(partsEndDate[2] + '/' + partsEndDate[1] + '/' + partsEndDate[0] + ' ' + partsEndDate[3]);

                        if (beginDate > endDate) {
                            isValid = false;
                            errorMessage = T.t('r_report_begin_date');

                        }
                        else if (props.startDate && props.endDate && dateValue) {
                            return _common.isDateRangeValid(props.startDate, props.endDate, dateValue, 2, props.dateFormat);
                        }

                        return isValid
                            ? true
                            : this.createError({
                                message: errorMessage,
                                path: this.path
                            });

                    }
                )
        });
    }

    GetActivityEndTime() {
        return Yup.string().when('dateCriteria', {
            is: val => val === 1,
            then: Yup.string()
                .min(1, T.t('r_one_character_required_validation'))
                .matches(RegExpTime, T.t('r_incorrect_input_format_validation'))
                .required(T.t('r_time_input_required_validation'))
        });
    }

    GetDatePrerequisiteActivityId() {
        return Yup.array().when('dateCriteria', {
            is: val => val === 2,
            then: Yup.array()
                .required(T.t('r_selection_required_validation'))
                .min(1, T.t('r_one_selection_required_validation'))
        });
    }

    GetDatePrerequisiteActivityHours() {
        return Yup.number().when('dateCriteria', {
            is: val => val === 2,
            then: Yup.number()
                .required(T.t('r_field_required'))
                .min(0, T.t('r_enter_valid_number_validation'))
        });
    }

    GetPrerequisiteActivityId() {
        return Yup.string().when('isActivityPrerequisite', {
            is: val => val === true,
            then: Yup.string()
            .required(T.t('r_select_activity_set_prerequisite'))
            .min(1, T.t('r_select_activity_set_prerequisite'))
        });
    }

    GetAssignmentMaximumUploadCount() {
        return Yup.number()
            .required(T.t('r_enter_number_validation'))
            .min(1, T.t('r_enter_valid_number_validation'))
            .max(10, T.t('r_assignment_max_file_uploads_max_validation'));
    }

    GetAssignmentMaximumFileSize() {
        return Yup.number()
            .required(T.t('r_enter_number_validation'))
            .min(5, T.t('r_assignment_max_file_size_max_validation'))
            .max(2000, T.t('r_assignment_max_size_grade_max_validation'));
    }

    GetActivityCompliletionTypeIsGrade() {
        return Yup.number().when('completionType', {
            is: val => val === 11,
            then: Yup.number()
                .required(T.t('r_enter_number_validation'))
                .min(0, T.t('r_enter_valid_number_validation'))
                .max(100, T.t('r_assignment_max_grade_max_validation'))
                .typeError(T.t('r_enter_valid_number_validation'))
        });
    }

    GetCompletionCriteriaProgress() {
        return Yup.number().when('completionType', {
            is: val => val === 2,
            then: Yup.number()
                .required(T.t('r_enter_number_validation'))
                .min(1, T.t('r_enter_valid_number_validation'))
                .max(100, T.t('r_assignment_max_grade_max_validation'))
        });
    }

    GetSelectActivity() {
        return Yup.array().when('dateCriteria', {
            is: val => val === 'criterionActivity',
            then: Yup.array()
                .required(T.t('r_selection_required_validation'))
                .min(1, T.t('r_one_selection_required_validation'))
                .nullable(),
            otherwise: Yup.array().notRequired()
        });
    }

    GetGrade() {
        return Yup.number().when('finishingCriterionActivity', {
            is: val => val === '11',
            then: Yup.number()
                .required(T.t('r_enter_number_validation'))
                .typeError(T.t('r_enter_valid_number_validation')),
            otherwise: Yup.number().notRequired()
        });
    }

    GetIsCommon() {
        return Yup.bool().required(T.t('r_field_required_isCommon'));
    }

    GetSelectedClass() {
        return Yup.array().when(['isCommon', 'isAllClass'], {
            is: (isAllClass, isCommon) => !isCommon && !isAllClass,
            then: Yup.array().required(T.t('r_field_required_selectClasses'))
        });
    }

    GetActivityTime() {
        return Yup.number()
            .when('dateCriteria', {
                is: val => val === 'criterionActivity',
                then: Yup.number()
                    .required(T.t('r_time_input_required_validation'))
                    .typeError(T.t('r_enter_valid_number_validation'))
                    .nullable(),
                otherwise: Yup.number().notRequired()
            })
            .typeError(T.t('r_enter_valid_number_validation'))
            .nullable()
            .notRequired();
    }

    // GetFileUploaded() {
    //     return Yup.bool().oneOf([true], T.t('r_gen_must_file_upload'));
    // }

    GetFileUploaded() {
        return Yup.boolean().test({
            message: T.t('r_gen_must_file_upload'),
            test:
                // tslint:disable-next-line
                function (value: any) {
                    return (props.isUploaded && props.isUploaded === true) === true ? true : value;
                }
        });
    }

    // GetFileOrFileEmbedUploaded() {
    //     return Yup.bool().oneOf([true], T.t('r_validation_gen_fileUploaded_or_fileEmbed'));
    // }

    GetFileOrFileEmbedUploaded() {
        return Yup.boolean().test({
            message: T.t('r_validation_gen_fileUploaded_or_fileEmbed'),
            test:
                // tslint:disable-next-line
                function (value: any) {
                    return (props.isUploaded && props.isUploaded === true) === true ? true : value;
                }
        });
    }

    GetVideoFileEmbedUploaded() {
        return Yup.boolean().test({
            message: T.t('r_validation_gen_video'),
            test:
                // tslint:disable-next-line
                function (value: any) {
                    return (props.isUploaded && props.isUploaded === true) === true ? true : value;
                }
        });
    }

    GetFileEmbed() {
        return Yup.string()
            .min(1, T.t('r_one_character_required_validation'))
            .max(255, T.t('r_must_be_less_characters_validation'));
    }

    GetTermWeekIds() {
        return Yup.array().when('dateCriteria', {
            is: val => val === 0,
            then: Yup.array()
                .required(T.t('r_selection_required_validation'))
                .min(1, T.t('r_one_selection_required_validation')),
            otherwise: Yup.array()
                .notRequired()
                .nullable()
        });
    }

    GetCompletionType() {
        return Yup.number().required(T.t('r_field_required_completion_type'));
    }

    GetCompletionCriteria() {
        return Yup.number().when('completionType', {
            is: val => (
                val === 12
                || val === 9
                || val === 10
            ),
            then: Yup.number()
                .required(T.t('r_enter_number_validation'))
                .min(0, T.t('r_enter_valid_number_validation')),
        });
    }

    GetVirtualClassTime() {
        return Yup.number()
            .min(15, T.t('r_gen_virtual_class_time_min_validate'))
            .required(T.t('r_video_warning_fieldrequired'));
    }

    GetActualStartTime() {
        return Yup.string()
            .required(T.t('r_video_warning_fieldrequired'))
            .test(
                'actualStartTime',
                T.t('r_enter_start_and_end_date_validation', {
                    0: _common.dateConvertToString(props.startDate, props.dateFormat),
                    1: _common.dateConvertToString(props.endDate, props.dateFormat)
                }),
                // tslint:disable-next-line
                function (dateValue: any) {
                    if (props.startDate && props.endDate && dateValue) {
                        return _common.isDateRangeValid(props.startDate, props.endDate, dateValue, 1, props.dateFormat);
                    }
                    return true;
                }
            )
            .test({
                name: 'actualStartTime',
                // tslint:disable-next-line
                test: function (dateValue: any) {
                    if (dateValue) {
                        let isValid: boolean | null = true;
                        let errorMessage = '';

                        if (dateValue && startTimeHour) {
                            const selectedDateFormat = props.dateFormat ? props.dateFormat : window.appSettings.DefaultDateFormat;
                            const _beginDate = Moment(dateValue + ' ' + startTimeHour, selectedDateFormat + ' HH:mm');
                            const _nowDate = Moment(new Date(), selectedDateFormat + ' HH:mm').subtract(5, 'minutes');

                            // if(_beginDate < _nowDate) {
                            //     isValid = false;
                            //     errorMessage = T.t('r_api_virtual_class_error_actualstarttime');
                            // }
                        }

                        return isValid
                            ? true
                            : this.createError({
                                message: errorMessage,
                                path: 'actualStartTime'
                            });
                    }
                    return true;
                }
            });
    }

    GetStartTimeHour() {
        return Yup.string().required(T.t('r_video_warning_fieldrequired'));
    }

    GetVirtualClassType() {
        return Yup.number()
            .required(T.t('r_video_warning_fieldrequired'))
            .nullable();
    }

    GetELessonType() {
        return Yup.number()
            .required(T.t('r_data_elessonType_validation'))
            .nullable();
    }



    GetPreparationTime() {
        return Yup.number().min(0, T.t('r_gen_virtual_class_preparation_time_min_validate'))
        .required(T.t('r_video_warning_fieldrequired'));
    }

    GetSubActivities() {
        return Yup.array().of(
            Yup.object().shape({
                activityType: Yup.number().moreThan(0, T.t('r_activity_validation_sub_activityType')),
                deadline: Yup.string()
                    .min(1, T.t('r_one_character_required_validation'))
                    .matches(RegExpDate, T.t('r_date_format_incorrect_validation'))
                    .required(T.t('r_date_required_validation'))
                    .test(
                        'subActivities',
                        T.t('r_enter_start_and_end_date_validation', {
                            0: _common.dateConvertToString(props.startDate, props.dateFormat),
                            1: _common.dateConvertToString(props.endDate, props.dateFormat)
                        }),
                        // tslint:disable-next-line
                        function (dateValue: any) {
                            if (props.startDate && props.endDate && dateValue) {
                                return _common.isDateRangeValid(props.startDate, props.endDate, dateValue, 1, props.dateFormat);
                            }
                            return true;
                        }
                    )
                    .test({
                        name: 'subActivities',
                        // tslint:disable-next-line
                        test: function (dateValue: any) {
                            if (dateValue) {
                                let isValid: boolean | null = true;
                                let errorMessage = '';
                                if (dateCriteria === DateCriteria.week) {
                                    // taskDeadline daki tarih seçilen haftalar arasindaki tarihte mi? validasyon fonksiyonu
                                    isValid = _common.isTaskDeadLineDateInWeeks(props.termWeeks, termWeekIds, dateValue, props.dateFormat);
                                    errorMessage = T.t('r_taskDeadline_not_in_selected_week_dates');
                                } else if (dateCriteria === DateCriteria.timeInterval && dateRange) {
                                    // taskDeadline secili zaman aralığında mı? validasyon
                                    isValid = _common.isDateRangeValid(dateValue, dateValue, dateRange, 3, props.dateFormat);
                                    errorMessage = T.t('r_taskDeadline_not_in_selected_date_range');
                                }
                                return isValid
                                    ? true
                                    : this.createError({
                                        message: errorMessage,
                                        path: this.path
                                    });
                            }
                            return true;
                        }
                    }),
                deadlineTime: Yup.string()
                    .min(1, T.t('r_one_character_required_validation'))
                    .matches(RegExpTime, T.t('r_time_format_incorrect_validation'))
                    .required(T.t('r_time_input_required_validation'))
            })
        );
    }

    // GetIsFileUploadEmpty() {
    //     return Yup.boolean().test({
    //         name: 'isFileUploadEmpty',
    //         message: T.t('r_validation_file_selected_not_uploaded'),
    //         test:
    //             // tslint:disable-next-line
    //             function(value: any) {
    //                 return value;
    //             }
    //     });
    // }

    GetIsFileUploadEmpty() {
        return Yup.boolean().test({
            name: 'isFileUploadEmpty',
            message: T.t('r_validation_file_selected_not_uploaded'),
            test:
                // tslint:disable-next-line
                function (value: any) {
                    return (props.isUploaded && props.isUploaded === true) === true ? true : value;
                }
        });
    }

    GetExamSessionBeginDate() {
        return Yup.string()
            .min(1, T.t('r_one_character_required_validation'))
            .matches(RegExpDate, T.t('r_date_format_incorrect_validation'))
            .required(T.t('r_date_required_validation'))
            .test(
                'examSessionBeginDate',
                T.t('r_enter_start_and_end_date_validation', {
                    0: _common.dateConvertToString(props.startDate, props.dateFormat),
                    1: _common.dateConvertToString(props.endDate, props.dateFormat)
                }),
                // tslint:disable-next-line
                function (dateValue: any) {
                    if (props.startDate && props.endDate && dateValue) {
                        return _common.isDateRangeValid(props.startDate, props.endDate, dateValue, 1, props.dateFormat);
                    }
                    return true;
                }
            )
            .test({
                name: 'examSessionBeginDate',
                // tslint:disable-next-line
                test: function (dateValue: any) {
                    if (dateValue) {
                        let isValid: boolean | null = true;
                        let errorMessage = '';
                        if (dateCriteria === DateCriteria.week) {
                            // examSessionBeginDate daki tarih seçilen haftalar arasindaki tarihte mi? validasyon fonksiyonu
                            isValid = _common.isTaskDeadLineDateInWeeks(props.termWeeks, termWeekIds, dateValue, props.dateFormat);
                            errorMessage = T.t('r_exam_session_begin_date_not_in_selected_week_dates');
                        } else if (dateCriteria === DateCriteria.timeInterval && dateRange) {
                            // examSessionBeginDate secili zaman aralığında mı? validasyon
                            isValid = _common.isDateRangeValid(dateValue, dateValue, dateRange, 3, props.dateFormat);
                            errorMessage = T.t('r_exam_session_begin_date_not_in_selected_date_range');
                        }
                        return isValid
                            ? true
                            : this.createError({
                                message: errorMessage,
                                path: 'examSessionBeginDate'
                            });
                    }
                    return true;
                }
            })
            .test({
                name: 'examSessionBeginDate',
                // tslint:disable-next-line
                test: function (dateValue: any) {
                    if (dateValue) {
                        let isValid: boolean | null = true;
                        let errorMessage = '';

                        if (examSessionBeginDate && examSessionBeginDateTime) {
                            const selectedDateFormat = props.dateFormat ? props.dateFormat : window.appSettings.DefaultDateFormat;
                            const _beginDate = Moment(examSessionBeginDate + ' ' + examSessionBeginDateTime, selectedDateFormat + ' HH:mm');
                            let _nowDate = new Date();
                            _nowDate.setHours(_nowDate.getHours() - 24);
                            const _before24HoursNowDate = Moment(_nowDate, selectedDateFormat + ' HH:mm');

                            if (_beginDate < _before24HoursNowDate) {
                                isValid = false;
                                errorMessage = T.t('r_gen_exam_session_past_error');
                            }
                        }

                        return isValid
                            ? true
                            : this.createError({
                                message: errorMessage,
                                path: 'examSessionBeginDate'
                            });
                    }
                    return true;
                }
            });
    }

    GetExamSessionBeginDateTime() {
        return Yup.string()
            .min(1, T.t('r_one_character_required_validation'))
            .matches(RegExpTime, T.t('r_incorrect_input_format_validation'))
            .required(T.t('r_time_input_required_validation'));
    }

    GetExamSessionEndDate() {
        return Yup.string()
            .min(1, T.t('r_one_character_required_validation'))
            .matches(RegExpDate, T.t('r_date_format_incorrect_validation'))
            .required(T.t('r_date_required_validation'))
            .test(
                'examSessionEndDate',
                T.t('r_enter_start_and_end_date_validation', {
                    0: _common.dateConvertToString(props.startDate, props.dateFormat),
                    1: _common.dateConvertToString(props.endDate, props.dateFormat)
                }),
                // tslint:disable-next-line
                function (dateValue: any) {
                    if (props.startDate && props.endDate && dateValue) {
                        return _common.isDateRangeValid(props.startDate, props.endDate, dateValue, 1, props.dateFormat);
                    }
                    return true;
                }
            )
            .test({
                name: 'examSessionEndDate',
                // tslint:disable-next-line
                test: function (dateValue: any) {
                    if (dateValue) {
                        let isValid: boolean | null = true;
                        let errorMessage = '';
                        if (dateCriteria === DateCriteria.week) {
                            // examSessionEndDate daki tarih seçilen haftalar arasindaki tarihte mi? validasyon fonksiyonu
                            isValid = _common.isTaskDeadLineDateInWeeks(props.termWeeks, termWeekIds, dateValue, props.dateFormat);
                            errorMessage = T.t('r_exam_session_end_date_not_in_selected_week_dates');
                        } else if (dateCriteria === DateCriteria.timeInterval && dateRange) {
                            // examSessionEndDate secili zaman aralığında mı? validasyon
                            isValid = _common.isDateRangeValid(dateValue, dateValue, dateRange, 3, props.dateFormat);
                            errorMessage = T.t('r_exam_session_end_date_not_in_selected_date_range');
                        }
                        return isValid
                            ? true
                            : this.createError({
                                message: errorMessage,
                                path: 'examSessionEndDate'
                            });
                    }
                    return true;
                }
            })
            .test({
                name: 'examSessionEndDate',
                // tslint:disable-next-line
                test: function (dateValue: any) {
                    if (dateValue) {
                        let isValid: boolean | null = true;
                        let errorMessage = '';

                        if (examSessionBeginDate && examSessionBeginDateTime) {
                            const selectedDateFormat = props.dateFormat ? props.dateFormat : window.appSettings.DefaultDateFormat;
                            const _beginDate = Moment(examSessionBeginDate + ' ' + examSessionBeginDateTime, selectedDateFormat + ' HH:mm');
                            const _endDate = Moment(examSessionEndDate + ' ' + examSessionEndDateTime, selectedDateFormat + ' HH:mm');

                            if (_beginDate > _endDate) {
                                isValid = false;
                                errorMessage = T.t('r_exam_session_end_date_bigger_than_begin_date');
                            }
                        }

                        return isValid
                            ? true
                            : this.createError({
                                message: errorMessage,
                                path: 'examSessionEndDate'
                            });
                    }
                    return true;
                }
            });
    }

    GetExamSessionEndDateTime() {
        return Yup.string()
            .min(1, T.t('r_one_character_required_validation'))
            .matches(RegExpTime, T.t('r_incorrect_input_format_validation'))
            .required(T.t('r_time_input_required_validation'));
    }

    GetExamDurationInMinutes() {
        return Yup.number()
            .required(T.t('r_enter_number_validation'))
            .min(1, T.t('r_enter_valid_number_validation'))
            .test({
                name: 'examDurationInMinutes',
                // tslint:disable-next-line
                test: function (minutes: any) {
                    if (minutes) {
                        let isValid: boolean | null = true;
                        let errorMessage = '';
                        if (examSessionBeginDate && examSessionBeginDateTime) {
                            const selectedDateFormat = props.dateFormat ? props.dateFormat : window.appSettings.DefaultDateFormat;
                            const _beginDate = Moment(examSessionBeginDate + ' ' + examSessionBeginDateTime, selectedDateFormat + ' HH:mm');
                            const _endDate = Moment(examSessionEndDate + ' ' + examSessionEndDateTime, selectedDateFormat + ' HH:mm');

                            if (_beginDate <= _endDate) {
                                const duration = Moment.duration(_endDate.diff(_beginDate));
                                const _minutes = duration.asMinutes();
                                if (minutes > _minutes && this.parent.examEntryDateType !== 0) {
                                    isValid = false;
                                    errorMessage = T.t('r_exam_duration_less_total_minutes');
                                }
                            }
                        }

                        return isValid
                            ? true
                            : this.createError({
                                message: errorMessage,
                                path: 'examDurationInMinutes'
                            });
                    }
                    return true;
                }
            });
    }

    GetExamShowAnswerSpecifiedDate() {
        return Yup.string()
            .matches(RegExpDate, T.t('r_date_format_incorrect_validation'))
            .test({
                name: 'examShowAnswerSpecifiedDate',
                // tslint:disable-next-line
                test: function (dateValue: any) {
                    if (dateValue) {
                        let isValid: boolean | null = true;
                        let errorMessage = '';

                        if (examSessionEndDate && examSessionEndDateTime) {
                            const selectedDateFormat = props.dateFormat ? props.dateFormat : window.appSettings.DefaultDateFormat;
                            const _examShowAnswerSpecifiedDate = Moment(
                                dateValue + ' ' + examShowAnswerSpecifiedDateTime,
                                selectedDateFormat + ' HH:mm'
                            );
                            const _endDate = Moment(examSessionEndDate + ' ' + examSessionEndDateTime, selectedDateFormat + ' HH:mm');

                            if (_examShowAnswerSpecifiedDate < _endDate) {
                                isValid = false;
                                errorMessage = T.t('r_exam_exam_show_answer_specified_date_bigger_than_end_date');
                            }
                        }

                        return isValid
                            ? true
                            : this.createError({
                                message: errorMessage,
                                path: 'examShowAnswerSpecifiedDate'
                            });
                    }
                    return true;
                }
            });
    }

    GetExamShowAnswerSpecifiedDateTime() {
        return Yup.string()
            .matches(RegExpTime, T.t('r_incorrect_input_format_validation'))
            .test({
                name: 'examShowAnswerSpecifiedDateTime',
                // tslint:disable-next-line
                test: function (dateValue: any) {
                    if (!dateValue && examShowAnswerSpecifiedDate) {
                        return this.createError({
                            message: T.t('r_time_input_required_validation'),
                            path: 'examShowAnswerSpecifiedDateTime'
                        });
                    }
                    return true;
                }
            });
    }

    GetCustomProperty5() {
        return Yup.number().test({
            name: 'customProperty5',
            // tslint:disable-next-line
            test: function (dateValue: any) {
                let isValid: boolean | null = true;
                let errorMessage = '';

                if (customProperty4) {
                    if (!dateValue) {
                        isValid = false;
                        errorMessage = T.t('r_enter_number_validation');
                    } else if (dateValue < 2) {
                        isValid = false;
                        errorMessage = T.t('r_exam_custom_property5_validation');
                    }
                }

                return isValid
                    ? true
                    : this.createError({
                        message: errorMessage,
                        path: 'customProperty5'
                    });
            }
        });
    }

    GetExamQuestionWeights() {
        return Yup.array().test({
            name: 'examQuestionWeights',
            test: function (data?: IExamQuestionWeights[]) {
                let isValid = true;
                let errorMessage = '';

                if (examQuestionWeightingType === -1) {
                    return true;
                }

                if (data && data?.length > 0) {
                    let totalScore = 0;
                    let totalCount = 0;

                    data.forEach((item) => {
                        totalScore += item.count * item.score;
                        totalCount += item.count;
                    });

                    if (totalScore !== 100) {
                        isValid = false;
                        errorMessage = T.t('r_exam_question_weights_total_score_error');
                    }
                    
                    if (totalCount !== examQuestionCount) {
                        isValid = false;
                        errorMessage = T.t('r_exam_question_weights_total_count_error');
                    }

                    data.forEach((item) => {
                        if (item.count > item.maxCount) {
                            isValid = false;
                            errorMessage =  T.t('r_exceeding_difficulty_level_error');
                        }
                    });
                } else {
                    isValid = false;
                    errorMessage = T.t('r_exam_question_weights_required');
                }

                return isValid
                    ? true
                    : this.createError({
                        message: errorMessage,
                        path: 'examQuestionWeightingType',
                    });
            },
        });
    }


    GetLtiName() {
        return Yup.array().when(['ltiId'], {
            is: ltiId => !ltiId,
            then: Yup.array()
                .required(T.t('r_activity_add_lti_name'))
                .min(1, T.t('r_one_selection_required_validation'))
                .typeError(T.t('r_activity_add_lti_name')),
            otherwise: Yup.array()
                .notRequired()
                .nullable()
        });
    }

    GetMasterCourseName() {
        return Yup.array().when(['masterCourseIds'], {
            is: masterCourseIds => !masterCourseIds,
            then: Yup.array()
                .required(T.t('r_questionBank_add_masterCourse'))
                .min(1, T.t('r_one_selection_required_validation'))
                .typeError(T.t('r_questionBank_add_masterCourse')),
            otherwise: Yup.array()
                .notRequired()
                .nullable()
        });
    }

    GetQuestionText() {
        return Yup.string().test({
            name: 'questionText',
            // tslint:disable-next-line
            test: function (value?: string) {
                let isValid: boolean | null = true;
                let errorMessage = '';

                if (!value) {
                  //  isValid = false;
                  //  errorMessage = T.t('r_questionBank_add_questionText');
                } else {
                    if (!value.replace(RegExpBase64, 'image').replace(RegExpHtmlTags, '')) {
                        isValid = false;
                        errorMessage = T.t('r_questionBank_add_questionText');
                    }

                    if (!value.replace(RegExpBase64, 'image').replace(RegExpHtmlTags, '').replace.length) {
                        isValid = false;
                        errorMessage = T.t('r_questionBank_add_questionText');
                    }
                }

                return isValid
                    ? true
                    : this.createError({
                        message: errorMessage,
                        path: 'questionText'
                    });
            }
        });
    }
    GetDescriptionUnRequired() {
        return Yup.string()
            .trim()
            .min(1, T.t('r_one_character_required_validation'))
            .max(255, T.t('r_must_be_less_characters_validation'));
    }

    GetNotEditable() {
        return Yup.number().test({
            name: 'questionType',
            // tslint:disable-next-line
            test: function (value?: number) {
                let isValid: boolean | null = true;
                let errorMessage = '';

                if (value !== props.initialQuestionType) {
                    isValid = false;
                    errorMessage = T.t('r_api_gen_question_error_not_editable_exam_question');
                }

                return isValid
                    ? true
                    : this.createError({
                        message: errorMessage,
                        path: 'questionType'
                    });
            }
        });
    }
    //#endregion
}
